<template>
    <div class="checkbox">
        <input :id="id"
            type="checkbox"
            v-bind="$attrs"
            @input="input($event.target.checked)"
            :checked="modelValue" />
        <label :for="id">{{ label }}</label>
    </div>
</template>
<script setup lang="ts">
defineProps({
    id: String,
    label: String,
    modelValue: Boolean,
})

const emit = defineEmits(["update:modelValue"]);

const input = (checked: boolean) => {
    emit("update:modelValue", checked);
};

</script>